module.exports = __webpack_public_path__ + "static/media/kerstman-red-velvet-1.0517c118.jpeg";